/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';

import { Translated } from 'utils/staticText';
import { RewardCopyrightText } from './i18n';

export function RewardCopyright(props: {
  staticText: Translated<typeof RewardCopyrightText>;
}): JSX.Element {
  return (
    <section className="flex flex-col items-center gap-[--spacing-gap-y] self-stretch border-t border-t-[--borders-default] pt-[--spacing-gap-y] md:pt-[--spacing-gap-section-y]">
      <div className="mhg-alpha-caption flex flex-col items-start gap-[--spacing-gap-y] self-stretch text-[--text-disabled] md:flex-row md:justify-between">
        <div className="flex flex-1 shrink-0 basis-0 items-start gap-[--spacing-gap-x-xs] self-stretch  md:order-last md:justify-end">
          <span>{props.staticText.toc}</span>
          <span>|</span>
          <span>{props.staticText.privacy}</span>
        </div>
        <div>{props.staticText.copyright}</div>
      </div>
    </section>
  );
}
